// AuthorityOS logo — hand-built SVG matching the chosen "specimen frame" concept.
// Four L-brackets forming a square + single ochre dot at center + serif wordmark.
// Colors inherit via CSS current color or use props for reversal on dark backgrounds.

export function Logo({ variant = "horizontal", className = "", inkColor = "#1A1915", accentColor = "#B8863C", wordmarkColor }) {
  const wm = wordmarkColor || inkColor;

  if (variant === "mark") {
    return (
      <svg viewBox="0 0 40 40" xmlns="http://www.w3.org/2000/svg" role="img" aria-label="AuthorityOS" className={className}>
        <g stroke={inkColor} fill="none" strokeWidth="1.6" strokeLinecap="square">
          <path d="M 2 10 L 2 2 L 10 2" />
          <path d="M 30 2 L 38 2 L 38 10" />
          <path d="M 2 30 L 2 38 L 10 38" />
          <path d="M 30 38 L 38 38 L 38 30" />
        </g>
        <circle cx="20" cy="20" r="3.4" fill={accentColor} />
      </svg>
    );
  }

  if (variant === "stacked") {
    return (
      <svg viewBox="0 0 220 130" xmlns="http://www.w3.org/2000/svg" role="img" aria-label="AuthorityOS" className={className}>
        <g transform="translate(90, 8)" stroke={inkColor} fill="none" strokeWidth="1.6" strokeLinecap="square">
          <path d="M 2 10 L 2 2 L 10 2" />
          <path d="M 30 2 L 38 2 L 38 10" />
          <path d="M 2 30 L 2 38 L 10 38" />
          <path d="M 30 38 L 38 38 L 38 30" />
        </g>
        <circle cx="110" cy="28" r="3.4" fill={accentColor} />
        <text
          x="110"
          y="92"
          fontFamily="Cormorant Garamond, ui-serif, Georgia, serif"
          fontSize="26"
          fill={wm}
          textAnchor="middle"
          fontWeight="500"
          letterSpacing="-0.4"
        >
          AuthorityOS
        </text>
        <line x1="70" y1="108" x2="150" y2="108" stroke={accentColor} strokeWidth="1" />
      </svg>
    );
  }

  // horizontal (default)
  return (
    <svg viewBox="0 0 240 40" xmlns="http://www.w3.org/2000/svg" role="img" aria-label="AuthorityOS" className={className}>
      <g stroke={inkColor} fill="none" strokeWidth="1.6" strokeLinecap="square">
        <path d="M 2 10 L 2 2 L 10 2" />
        <path d="M 30 2 L 38 2 L 38 10" />
        <path d="M 2 30 L 2 38 L 10 38" />
        <path d="M 30 38 L 38 38 L 38 30" />
      </g>
      <circle cx="20" cy="20" r="3.4" fill={accentColor} />
      <text
        x="54"
        y="28"
        fontFamily="Cormorant Garamond, ui-serif, Georgia, serif"
        fontSize="26"
        fill={wm}
        fontWeight="500"
        letterSpacing="-0.4"
      >
        AuthorityOS
      </text>
    </svg>
  );
}
